<template>
  <div class="rule-content" v-show="isShow">
    <div
      class="content"
      :style="{'background-image': `url(${lg(config, 'season_rule', '')})`, transform: `scale(${scale})`}"
      @click="close"
    >
      <div class="close"></div>
    </div>
  </div>
</template>

<script setup>
import lg from '@/utils/lg'
import { ref, computed } from 'vue'
import { useAppStore } from '@/store'
import { useConfig } from '@/composables/useConfig'
import { useModal } from '@/composables/useModal'

const appStore = useAppStore()

const isShow = ref(false)
const { close } = useModal('apply-rule', isShow)

const scale = computed(() => appStore.scale)
const config = useConfig()
</script>

<style lang="scss" scoped>
.rule-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
  .content {
    position: absolute;
    width: 1286px;
    height: 724px;
    top: 50%;
    left: 50%;
    margin-left: -0.5 * 1286px;
    margin-top: -0.5 * 724px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    .close {
      background-image: $icon_close;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 51px;
      height: 28px;
      position: absolute;
      top: 0;
      right: -50px;
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;
    }
  }
}
</style>
